import { render, staticRenderFns } from "./Minha-conta.vue?vue&type=template&id=76457a4e&"
import script from "./Minha-conta.vue?vue&type=script&lang=js&"
export * from "./Minha-conta.vue?vue&type=script&lang=js&"
import style0 from "./Minha-conta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports